// extracted by mini-css-extract-plugin
export var customLogo = "styles-module--custom-logo--kLM96";
export var customLogos = "styles-module--custom-logos--srOSH";
export var primary = "#06004d";
export var secondary = "#4dafd7";